import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import configureStore from './store/configureStore';
import { resetApp } from './containers/App/actions';
import App from './App/App';
import { AuthenticatingPage, NotEmailPage } from './components';
import { FeatureFlagProvider } from './providers/FeatureFlagProvider';
import ensurePublicClientApplicationCreated from './appAuth/msalAuth';

const store = configureStore({});

interface BootstrapAddinProps {
  resetStore: boolean;
  isItemEmail: boolean;
}
const BootstrapAddin = ({ resetStore, isItemEmail }: BootstrapAddinProps) => {
  // eslint-disable-next-line no-console
  console.log('*** BootstrapAddin');
  const [readyToRender, setReadyToRender] = React.useState(false);
  const [msalInstance, setMsalInstance] = React.useState<IPublicClientApplication>();
  useEffect(() => {
    if (resetStore) {
      store.dispatch(resetApp);
    }
    setReadyToRender(true);
  }, [resetStore]);

  useEffect(() => {
    let stillMounted = true;
    ensurePublicClientApplicationCreated().then(instance => {
      if (!stillMounted) return;
      setMsalInstance(instance);
    });
    return () => { stillMounted = false; };
  }, []);

  // Need to ensure that the store is reset before rendering the app
  if (!readyToRender) {
    return null;
  }

  if (!isItemEmail) {
    return <NotEmailPage />;
  }

  if (!msalInstance) {
    return <AuthenticatingPage />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <FeatureFlagProvider>
          <App />
        </FeatureFlagProvider>
      </Provider>
    </MsalProvider>
  );
};

export default BootstrapAddin;
